<template>
	<a-modal width="55%" title="详情" :visible="visible" centered :destroy-on-close="true" :mask-closable="false"
		:confirm-loading="confirmLoading" :footer="null" @ok="onSubmit" @cancel="onClose">
		<a-descriptions :column="2">
			<a-descriptions-item label="企业名称">{{ form.companyName }}</a-descriptions-item>
			<a-descriptions-item label="需求名称">{{ form.name }}</a-descriptions-item>
			<a-descriptions-item label="需求类型">
				<dict-render :dict-obj="dictObjs['demand_type']" :text="form.trType" v-if="form.trType"></dict-render>
			</a-descriptions-item>
			<a-descriptions-item label="所属高新技术领域">
				<dict-render :dict-obj="dictObjs['belong_techField']" :text="form.highTechField"
					v-if="form.highTechField"></dict-render>
			</a-descriptions-item>
			<!-- <a-descriptions-item label="项目阶段">
				<dict-render :dict-obj="dictObjs['projectStage']" :text="form.projectPhase"
					v-if="form.projectPhase"></dict-render>
			</a-descriptions-item>
			<a-descriptions-item label="需求优先级">
				<dict-render :dict-obj="dictObjs['demand_priority']" :text="form.priority" v-if="form.priority"></dict-render>
			</a-descriptions-item> -->
			<a-descriptions-item label="研究经费(万元)">{{ form.researchFunding }}</a-descriptions-item>
			<a-descriptions-item label="截止日期">{{ form.deadline && form.deadline.split(' ')[0] }}</a-descriptions-item>
			<a-descriptions-item label="需求价值">
				<dict-render :dict-obj="dictObjs['demand_value']" :text="form.demandValue" v-if="form.demandValue"></dict-render>
			</a-descriptions-item>
			<a-descriptions-item label="需求对接人">{{ form.dockingPerson }}</a-descriptions-item>
			<a-descriptions-item label="联系电话">{{ form.contactNumber }}</a-descriptions-item>
			<a-descriptions-item label="合作类型">
				<dict-render :dict-obj="dictObjs['cooperation_methods']" :text="form.typeCooperation"
					v-if="form.typeCooperation"></dict-render>
			</a-descriptions-item>
			<a-descriptions-item label="需求描述" :span="2">{{ form.description }}</a-descriptions-item>
			<a-descriptions-item label="附件">
				<img-upload v-model:value="form.file" :showBtn="false" :disabled="true" />
			</a-descriptions-item>
		</a-descriptions>
	</a-modal>
</template>
<script>
import { formMixin, dictMixin } from "@/mixins";
import DictRender from "@/components/other/DictRender";

export default {
	name: "DetailModal",
	components: {
		DictRender
	},

	mixins: [formMixin, dictMixin],
	data() {
		return {
			dictNames: "demand_type,belong_techField,projectStage,demand_priority,demand_value,cooperation_methods,education_background,research_field,expert_type",
			form: {
				parentId: null,
			},
		}
	},
}
</script>
<style scoped lang="less"></style>
